<template>
  <BaseDialog
    :visible="visible"
    @update:visible="(val) => emit('update:visible', val)"
    :width="dialogWidth"
    :height="dialogHeight"
    :defaultTitleStyle="true"
    :class="['confirmation-dialog !rounded-[23px]', props.dialogClass]"
  >
    <div
      :style="{
        backgroundImage: `url(${dashboardBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: '50% auto',
      }"
      class="relative w-full flex justify-center items-center h-full overflow-hidden"
    >
      <div
        class="absolute inset-0 flex justify-center items-center pointer-events-none z-0"
      ></div>
      <div class="relative z-10 flex flex-col items-center w-full p-8 md:p-12">
        <div
          :class="[
            'gap-[16.4px] rounded-full flex items-center justify-center',
            windowWidth < 640 
              ? 'w-[100px] h-[100px] px-[12px] py-6' 
              : 'w-[164px] h-[164px] px-[16.4px] py-8'
          ]"
          :style="props.svgStyle"
        >
          <span
            class="flex justify-center items-center"
            v-html="props.svg"
          ></span>
        </div>
        <div class="gap-5 text-center mt-[31.5px]">
          <h1
            :class="[
              'text-btnActive items-center font-just text-[24px] md:text-[32px] leading-[100%] tracking-[0%] font-500',
              props.titleClass,
            ]"
          >
            {{ title }}
        </h1>
          <div class="mt-5 text-center">
            <p
              :class="[
                'text-black/60 font-just text-[16px] md:text-[20px] leading-[23px] tracking-[0%] font-normal',
                props.subtitleClass,
              ]"
              v-html="subtitle"
            ></p>
          </div>
        </div>

        <!-- ADD THIS SLOT FOR CUSTOM CONTENT -->
        <slot></slot>
      </div>
    </div>
  </BaseDialog>
</template>

<script setup>
import { shareSvg } from "@/utils/commonSvg";
import { computed, onMounted, ref, watch, onUnmounted } from "vue";
const dashboardBg = new URL("@/assets/images/dashboard.png", import.meta.url)
  .href;

const emit = defineEmits(["ok", "cancel", "update:visible", "verify"]);
const props = defineProps({
  isAuthenticate: Boolean,
  isAuthenticateItem: {},
  visible: { type: Boolean, required: true },
  successIcon: {},
  svg: {},
  title: { type: String },
  subtitle: { type: String },
  titleClass: { type: String, default: "" },
  subtitleClass: { type: String, default: "" },
  dialogClass: { type: String, default: "" },
  svgStyle: { type: [String, Object, Array], default: "" },
  autoClose: { type: Boolean, default: false },
  duration: { type: Number, default: 2000 },
});
const shareIcon = shareSvg({ width: "24", height: "24", color: "#000000" });

const windowWidth = ref(window.innerWidth);

const dialogWidth = computed(() => {
  return windowWidth.value < 768 ? "100%" : "55%";
});

const dialogHeight = computed(() => {
  return windowWidth.value < 768 ? "100%" : "70%";
});

let timer = null;

const clearTimer = () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
};

watch(
  () => [props.visible, props.autoClose, props.duration],
  ([visible, autoClose, duration]) => {
    clearTimer();
    if (visible && autoClose) {
      timer = setTimeout(() => {
        emit("update:visible", false);
      }, duration);
    }
  },
  { immediate: true }
);

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  clearTimer();
});
</script>

<style>
.p-dialog-content {
  height: 100%;
}
</style>
